import { render } from "./CustomerUsersView.vue?vue&type=template&id=57e3857c&lang=pug"
import script from "./CustomerUsersView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerUsersView.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__